import React from 'react'
import Stack from './Stack'

export default function BottomStickyBar ({ children, bg = 'bg.subtle', ...props }) {
  return (
    <Stack
      bg={bg}
      p={3}
      direction='row'
      shadow='md'
      rounded='md'
      justifyContent='space-between'
      alignItems='center'
      position='sticky'
      bottom='10px'
      zIndex={10}
      {...props}
    >
      {children}
    </Stack>
  )
}
